const { getElement } = window.BAO.Utils

export class BundleVariantSelect extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setupFauxSelect()

    this.setupSelectListeners()

    this.handleSelectChange()
  }

  setupFauxSelect () {
    const fauxSelects = this.els.fauxSelect?.elements

    fauxSelects?.forEach(el => {
      const options = el.querySelector('.prd-DetailVariants_FauxSelectOptions')
      const chevron = el.querySelector('.prd-DetailVariants_Chevron')

      el.addEventListener('click', () => {
        const currentOpenSelects = document.querySelectorAll('.prd-DetailVariants_FauxSelectOptions-active')
        const currentOpenChevron = document.querySelectorAll('.prd-DetailVariants_Chevron-active')
        currentOpenSelects.forEach(select => {
          if (select !== options) {
            select.classList.remove('prd-DetailVariants_FauxSelectOptions-active')
          }
        })
        currentOpenChevron.forEach(chev => {
          if (chev !== chevron) {
            chev.classList.remove('prd-DetailVariants_Chevron-active')
          }
        })

        options.classList.toggle('prd-DetailVariants_FauxSelectOptions-active')
        chevron.classList.toggle('prd-DetailVariants_Chevron-active')
      })

      const fauxSelectedOption = el.querySelector('.prd-DetailVariants_SelectShade')
      const fauxOptions = el.querySelectorAll('.prd-DetailVariants_FauxOption')
      const realSelect = el.parentElement.querySelector('.prd-DetailVariants_Select')

      fauxOptions.forEach(option => {
        option.addEventListener('click', () => {
          fauxSelectedOption.innerHTML = option.innerHTML
          fauxSelectedOption.classList.add('prd-DetailVariants_FauxOption')
          fauxSelectedOption.classList.remove('prd-DetailVariants_SelectShade')

          fauxOptions.forEach(opt => {
            opt.classList.remove('prd-DetailVariants_FauxOption-active')
          })

          realSelect.querySelectorAll('option').forEach(realOption => {
            if (realOption.value === option.dataset.variant) {
              realOption.selected = true
              option.classList.add('prd-DetailVariants_FauxOption-active')

              realSelect.closest('select').dispatchEvent(new Event('change', { bubbles: true }))
            }
          })
        })
      })
    })
  }

  setupSelectListeners () {
    const selectElements = this.els.option.elements

    selectElements.forEach(el => {
      el.addEventListener('change', this.handleSelectChange)
    })
  }

  handleSelectChange () {
    const selectElements = document.querySelectorAll('.prd-DetailVariants_Select')

    const selectedValues = []
    selectElements.forEach(el => {
      selectedValues.push(el.value)
    })

    const multipackInput = document.querySelector('[data-bundle-variant-select-external-el="multipack"]')

    if (multipackInput) {
      const multipackValues = []
      let inStock = true

      selectElements.forEach(el => {
        const selectedOption = el.options[el.selectedIndex]
        const firstAvailableOption = Array.from(el.options).find(option =>
          option.dataset.variantAvailable === 'true',
        )

        if (firstAvailableOption) {
          multipackValues.push(selectedOption.dataset.variantId)
        } else {
          inStock = false
        }
      })

      const atcButton = getElement('.prd-DetailForm_Form .prd-DetailForm_Button')
      if (inStock) {
        atcButton.disabled = false
      } else {
        atcButton.innerText = window.theme.strings.soldOut
      }

      multipackInput.value = multipackValues
    } else {
      const productHandle = this.dataset.productHandle

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          const matchingVariant = product.variants.find(variant => {
            return variant.options.every((opt, index) => opt === selectedValues[index])
          })

          if (matchingVariant) {
            document.querySelector('[data-bundle-variant-select-external-el="variant"]').value = matchingVariant.id
          } else {
            console.info('No matching variant found.')
          }
        })
        .catch(error => {
          console.error('Error fetching product data:', error)
        })
    }
  }
}

if (!customElements.get('bundle-variant-select')) {
  customElements.define('bundle-variant-select', BundleVariantSelect)
}
